import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Card, Typography } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

type Props = {
  admin: { name: string; email: string };
};

export const AdminHr: FC<Props> = ({ admin }) => {
  const t = useTranslations('settings.tabs.delegates.admin');

  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <Card mt='xs' display='flex' flexDirection='column'>
      <Typography variant='h3' mb='xs' flex='1'>
        {t('title')}
      </Typography>
      <Box
        width='100%'
        flex='1'
        display='flex'
        flexDirection={genericResponsiveValue({
          breakPoints: { desktop: 'row' },
          defaultValue: 'column',
        })}
      >
        <Box
          display='flex'
          flexDirection={genericResponsiveValue({
            breakPoints: { desktop: 'row' },
            defaultValue: 'column',
          })}
          width='100%'
        >
          <Box flex='1'>
            <Typography variant='p2' mb='xxs' color='grey/light'>
              {t('firstName')}
            </Typography>
            <Typography variant='p2/light'>{admin?.name || '--'}</Typography>
          </Box>
          <Box
            flex='1'
            mt={genericResponsiveValue({
              breakPoints: { desktop: 'none' },
              defaultValue: 'xs',
            })}
          >
            <Typography variant='p2' mb='xxs' color='grey/light'>
              {t('email')}
            </Typography>
            <Typography variant='p2/light'>{admin?.email || '--'}</Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
